import * as Departments from 'Modules/DepartmentModule';
import { Department } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: Department.GET_CLIENT_LEARNING_INFO_INIT,
});

export const success = (data) => ({
  type: Department.GET_CLIENT_LEARNING_INFO_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Department.GET_CLIENT_LEARNING_INFO_FAILURE,
});

const getClientLearningInfo = () => async (dispatch) => {
  dispatch(init());
  try {
    const response = await Departments.Connector.getClientLearningInfo();
    dispatch(success(response.data));
    return response.data;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default getClientLearningInfo;
